import * as d3 from 'd3'
export default {
  methods: {

    recommend_Values(selection) {
      let count = 0
      for(let i=1; i<6; i++) {
        if(d3.select(`#FORM_STAGE_${i}`).text()) count ++
      }

      let message = []
      if(count==0) {
        // Required before
        message[0] = {text: `Input values are required before`}
        message[1] = {text: `using this feature.`}
        this.gmx_openPopup(selection, {type: 'Alert', msg: message})
      } else if(count>3) {
        // Recommended values
        message[0] = {text: `Recommended values support up to `}
        message[1] = {text: `three stages only.`}
        message[2] = {text: `Please contact the administrator.`, color: '#757575', size: 11}
        this.gmx_openPopup(selection, {type: 'Alert', msg: message})
      } else {
        for(let i=1; i<6; i++) {
          d3.select(`#FORM_STAGE_${i}`).text(i<=count ? this.recommend[count][i].STAGE : '')
          d3.select(`#FORM_X_${i}`).text(i<=count ? this.recommend[count][i].X : '')
          d3.select(`#FORM_Y_${i}`).text(i<=count ? this.recommend[count][i].Y : '')
          d3.select(`#FORM_WIDTH_${i}`).text(i<=count ? this.recommend[count][i].WIDTH : '')
          d3.select(`#FORM_SPACE_${i}`).text(i<=count ? this.recommend[count][i].SPACE : '')
        }
      }
    },


    save_Stage(selection) {

      let newDataArray = []
      let emptyCnt = 0
      for(let i=1; i<6; i++) {

        let dataSet = {}
        if(d3.select(`#FORM_STAGE_${i}`).text()) {
          this.stgFields.forEach(d=> {
            let getData = d3.select(`#FORM_${d.code}_${i}`).text()
            if(getData || getData == 0) {
              dataSet[d.code] = d.format == 'num' ? Number(getData) : getData
            } else { emptyCnt ++ }
          })
        }
        if(dataSet.STAGE) newDataArray.push(dataSet)
      }

      let message = []
      if(emptyCnt>0) {
        // Required fields
        message[0] = {text: `Please fill in all required fields.`}
        this.gmx_openPopup(selection, {type: 'Alert', msg: message})
      } else {

        // UPDATE
        this.stg_Update(newDataArray, `IDX = '${this.winProps.idx}'`).then(() => {
          this.db_Stage = this.cbData.data
          this.close_Window()
        })

      }
    },


  }
}